<template>
  <div>
    <nav class="navbar navbar-default navbar-fixed-top app-navbar">
      <div class="container-fluid">
        <div class="navbar-header">
          <button
            v-if="isAuthenticated"
            type="button"
            class="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#navbar-collapse-1"
            aria-expanded="false"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link
            v-if="current_user && isAuthenticated"
            to="/reports/create"
            class="navbar-brand"
          >
            <img src="/images/end-customer-logo.png" />
          </router-link>
          <router-link v-else to="/" class="navbar-brand">
            <img src="/images/end-customer-logo.png" />
          </router-link>
        </div>
        <div class="collapse navbar-collapse" id="navbar-collapse-1">
          <ul class="nav navbar-nav">
            <li v-if="current_user && isAuthenticated">
              <router-link class="nav-link" to="/reports/create" v-if="isAuthenticated">
                <span class="fas fa-plus-circle" aria-hidden="true"></span> New Report
              </router-link>
            </li>
            <li v-if="current_user && isAuthenticated">
              <router-link class="nav-link" to="/reports" v-if="isAuthenticated">
                <span class="fas fa-copy" aria-hidden="true"></span> Your Reports
              </router-link>
            </li>
            <li v-if="current_user && isAuthenticated">
              <router-link class="nav-link" to="/companies" v-if="isAuthenticated">
                <span class="fas fa-building" aria-hidden="true"></span> Your Companies
              </router-link>
            </li>
          </ul>
          <ul class="nav navbar-nav navbar-right" v-if="current_user && isAuthenticated">
            <li class="dropdown">
              <a
                href="#"
                class="dropdown-toggle"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span class="fas fa-user" aria-hidden="true"></span> {{ currentUserName }}
                <span class="caret"></span>
              </a>
              <ul class="dropdown-menu">
                <li>
                  <router-link
                    class="dropdown-item"
                    to="/logout"
                    data-toggle="collapse"
                    data-target="#navbar"
                    v-on:click.native="logout()"
                  >
                    <span class="fas fa-sign-out-alt" aria-hidden="true"></span>Log Out
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <report-navbar v-if="$route.name === 'ReportsShow'"></report-navbar>
  </div>
</template>

<script>
import ReportNavbar from '@/components/reports/components/ReportNavbar';
import { AppConfig } from '@/config/config';
import store from '@/packages/vuex/store';
import { mapGetters } from 'vuex';

export default {
  components: {
    ReportNavbar,
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'client', 'current_user']),
    currentUserName() {
      if (this.current_user !== undefined) {
        return this.current_user.name;
      }
      return 'n/a';
    },
    // isAxaAdmin: function() {
    //   return current_user.allroles.search('ignition_admin')
    // },
    // isCompanyAdmin: function() {
    //   return current_user.allroles.search('super_admin')
    // }
    // isSuperAdmin: function() {
    //   return current_user.allroles.search('super_admin')
    // }
  },
  data() {
    return {
      title: AppConfig.title,
    };
  },
  methods: {
    async get_authenticated_user() {
      await store.dispatch('fetch_user');
    },
    logout() {
      this.$auth.destroyToken();
      this.$store.dispatch('logout', false);
      this.$router.push('/');
      // this.$store.commit("STOP_SESSION_MANAGEMENT");
    },
    // isSuperAdmin: function () {
    //   return current_user.allroles.search('super_admin')
    // },
  },
  mounted() {
    /*
     * This is a little trick to force things to get updated before we do
     * anything with them.
     * get_authenticated_user is essentially an async function (because of
     * the Axios GET /api/v1/users inside the fetch_user action), and we state
     * that we want to wait for the fetch_user action to complete.
     * This results in current_name.name() being valid, because current_user
     * then references an actual User object.
     */
    this.get_authenticated_user();
  },
  props: ['appconfig'],
  watch: {
    client() {},
  },
};

// TODO Verify if this is still needed
// Fixes issue with Navbar not closing when mobile menu is clicked.
// $(document).on("click", ".navbar-collapse.in", function (e) {
//   if ($(e.target).is("a")) {
//     $(this).collapse("hide");
//   }
// });
</script>

<style>
.app-navbar {
  background-color: #1a75cf;
  min-height: 75px;
}

.navbar-default {
  font-size: 1rem;
  font-weight: 400;
  padding: 10px;
  border: 0px;
  border-radius: 0px;
  color: #ffffff;
  text-transform: uppercase;
}

.navbar-brand {
  float: left;
  min-height: 55px;
  padding: 0 15px 20px;
}

.navbar-default {
  font-size: 1rem;
  font-weight: 400;
  padding: 10px;
  border: 0px;
  border-radius: 0px;
  color: #ffffff;
  text-transform: uppercase;
}

.navbar-default .navbar-nav > li > a {
  color: #ffffff;
}

.navbar-default .navbar-nav > li > a:hover {
  color: #cbf0ff;
}

.navbar-default .navbar-brand {
  color: #002433;
}

.navbar-default .navbar-brand:hover {
  color: #ffffff;
  text-shadow: 1px -1px 8px #b3e9ff;
}

.navbar-default .navbar-nav > .open > a,
.navbar-default .navbar-nav > .open > a:hover,
.navbar-default .navbar-nav > .open > a:focus {
  background-color: #003352;
  color: #ffffff;
}

.navbar-default .navbar-toggle {
  border: none;
}

.navbar-default .navbar-collapse,
.navbar-default .navbar-form {
  border: none;
}

.navbar-default .navbar-toggle:hover,
.navbar-default .navbar-toggle:focus {
  background-color: #002433;
}

.navbar-default .navbar-toggle .icon-bar {
  background-color: #ffffff;
}

.navbar-empty-notification {
  color: #ffffff;
  font-size: x-large;
}
.navbar-notification {
  color: #ff8400;
  font-size: x-large;
}
.navbar-notification > span {
  position: relative;
  left: -5px;
}

.dropdown-menu {
  font-size: 1rem;
  font-weight: 400;
  background-color: #003352;
  color: white;
  border: 0px;
  border-radius: 2px;
  padding-top: 10px;
  padding-bottom: 10px;
  z-index: 10;
}

.dropdown-menu > li > a {
  background-color: #003352;
  color: white;
}

.dropdown-menu > li > a:hover,
.dropdown-menu > li > a:focus {
  background-color: #003352;
  color: white;
}

.dropdown-menu .divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #003246;
}

.dropdown-item > span {
  margin-right: 0.25rem;
}

.navbar-default .navbar-nav .open .dropdown-menu > li > a {
  color: #ffffff;
}

.header-notification {
  font-size: larger;
}
</style>
